export default {
  design2: 1,
  havenly3DManual: 2,
  havenly3DStudio: 3,
  havenly3DFloorplanner: 4,
  staffDesigners: 6,
  elevenStar: 7,
  inPerson: 8,
  skipRenderQC: 9,
  overstock: 10,
  havenlyAIGeneratedBoardDescription: 12,
  aiRecommendedIdeas: 13
};
